import React from 'react';

import dynamic from 'next/dynamic';
const BetaLanguageTooltip = dynamic(() => import('../components/atoms/BetaTooltip'));

export const LANGUAGE_OPTIONS = [
  {
    label: (
      <div className='d-flex align-items-start' data-langmodal='true'>
        English
      </div>
    ),
    value: 'en',
    text: 'English'
  },
  {
    label: (
      <div className='d-flex align-items-start' data-langmodal='true'>
        हिन्दी (Hindi) <BetaLanguageTooltip />
      </div>
    ),
    value: 'hi',
    text: 'हिन्दी'
  },
  {
    label: (
      <div className='d-flex align-items-start' data-langmodal='true'>
        తెలుగు (Telugu) <BetaLanguageTooltip />
      </div>
    ),
    value: 'te',
    text: 'తెలుగు'
  },
  {
    label: (
      <div className='d-flex align-items-start' data-langmodal='true'>
        मराठी (Marathi) <BetaLanguageTooltip />
      </div>
    ),
    value: 'mr',
    text: 'मराठी'
  },
  {
    label: (
      <div className='d-flex align-items-start' data-langmodal='true'>
        ಕನ್ನಡ (Kannada) <BetaLanguageTooltip />
      </div>
    ),
    value: 'ka',
    text: 'ಕನ್ನಡ'
  }
];

export const useTranslation = () => {
  const t = (title) => title;

  return { t };
};
